module.exports = __webpack_public_path__ + "static/adjustable-base-tufted-807987146da1d2eeef2eae8b275dca15.jpeg";